import { render, staticRenderFns } from "./bandejaAutorizaciones.vue?vue&type=template&id=7bc5887c&scoped=true"
import script from "./bandejaAutorizaciones.vue?vue&type=script&lang=js"
export * from "./bandejaAutorizaciones.vue?vue&type=script&lang=js"
import style0 from "./bandejaAutorizaciones.vue?vue&type=style&index=0&id=7bc5887c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc5887c",
  null
  
)

export default component.exports